export default {
  computed: {
    currentUser() {
      return this.$store.state.user;
    }
  },
  methods: {
    $loading(showLoading) {
      this.$store.dispatch("LOADING", showLoading).then(res => {});
    },
    $globalLoading({ loading, text }) {
      this.$store.dispatch("GLOBAL_LOADING", { loading, text });
    },
    $authHeaders() {
      const apiAccessToken = localStorage.getItem("ruminote.apiAccessToken");
      let authHeaders = {
        headers: { Authorization: `Bearer ${apiAccessToken}` }
      };
      return authHeaders;
    }
  }
};
